import i18n from 'src/i18n';
import { updateObject, getAppointmentViewState } from 'src/services/functions';

export const getPractitionerName = pr => {
  if (pr && Array.isArray(pr.localizations)) {
    const localization = pr.localizations.find(e => e.lang === i18n.language);
    return (localization && localization.name) || pr.localizations[0].name;
  }
  return null;
};

export const getTranslateDocSpecialties = (practitioner, separator = ', ') => {
  const currentLang = i18n && i18n.language;
  if (practitioner && practitioner.specialties && Array.isArray(practitioner.specialties)) {
    const { specialties } = practitioner;
    const translateSpecialties = specialties.map(
      sp => sp && sp.translations && sp.translations[currentLang]
    );
    if (translateSpecialties && translateSpecialties.length) {
      return translateSpecialties.join(separator);
    }
    return null;
  }
  return null;
};

// Filters in local store
export const localAppointmentsFilters = {
  locName: 'appointsFilters',
  clear: function () {
    localStorage.removeItem(this.locName);
  },
  get: function (name) {
    const str = localStorage.getItem(this.locName);
    if (str) {
      const obj = JSON.parse(str);
      return obj[name];
    }
    return null;
  },
  set: function (updateObj) {
    const storedFilters = localStorage.getItem(this.locName);
    const actualFilters = storedFilters ? JSON.parse(storedFilters) : {};
    localStorage.setItem(this.locName, JSON.stringify(updateObject(actualFilters, updateObj)));
  }
};

//──── Methods for appointment status ───────────────────────────────────────────────────
export const filterAppointsByStatuses = (appointsList, selectStatuses) => {
  let filterList = [];
  if (Array.isArray(appointsList) && appointsList && Array.isArray(selectStatuses)) {
    filterList = appointsList.filter(appointment => {
      const appointStatus = getAppointmentViewState(appointment);
      return (selectStatuses.find(statuses => statuses.indexOf(appointStatus) > -1));
    });
  }
  return filterList;
};

export const updateAppointsStatuses = (currentStatuses, newStatuses) => {
  let statusList = [];
  if (!currentStatuses) { // first init
    statusList = [...newStatuses];
  } else { // update
    statusList = [...currentStatuses];
    const index = statusList.findIndex(st => String(st) === String(newStatuses));
    if (index > -1) {
      statusList.splice(index, 1);
    } else {
      statusList.push(String(newStatuses));
    }
  }
  return statusList;
};

export const filterAppointsByCampus = (appointmentsList, campusId) => {
  if (Array.isArray(appointmentsList)) {
    if (campusId) {
      return appointmentsList.filter(
        appointment => String(appointment.campus.id) === String(campusId)
      );
    } else if (!campusId) {
      return appointmentsList;
    }
  }
};